import React, { useRef } from 'react'
import styles from './Heading.module.scss'

const Text = () => {

    const wordHighlight = useRef(null)
    const word = useRef(null)

    // Array fill polyfill function instead of extending prototype
    const fillArray = (array, value, start = 0, end) => {
        const len = array.length;
        const actualStart = start < 0 ? Math.max(len + start, 0) : Math.min(start, len);
        const actualEnd = end === undefined ? len : (end < 0 ? Math.max(len + end, 0) : Math.min(end, len));
        
        for (let i = actualStart; i < actualEnd; i++) {
            array[i] = value;
        }
        return array;
    }

    const wordBank = [
        "REACT.JS",
        "NEXT.JS",
        "NODE.JS",
        "REACT NATIVE",
        "GOOGLE CLOUD",
        "AWS",
        "SQL",
        "THREE.JS",
        "WEB3.JS",
        "BLOCKCHAIN",
    ];
    var currentNum = 0,
        currentIteration = 0,
        maxNumIterations = 13,
        minNumIterations = 10,
        letterBank = "abcdefghijklmnopqrstuvwxyz";

    const getIterations = (initWord, finWord, iterationNum) => {
        if (wordHighlight.current) {
            var iterations = [],
                correctLetters = fillArray(new Array(finWord.length), false),
                proportion = iterationNum / 2;

            for (var i = 0; i < iterationNum; i++) {
                var iteration = i > 0 ? iterations[i - 1] : initWord.split("");

                iteration.length -= Math.round((iteration.length - finWord.length) / (iterationNum - i));

                for (var j = 0; j < iteration.length; j++) {
                    var changeMe = Math.random() <= 0.5 ? true : false;

                    if (changeMe && proportion < i) {
                        // Unscramble the second half of iterations
                        iteration[j] = finWord[j];
                        correctLetters[i] = true;
                    } else if ((changeMe && proportion >= i)
                        || (!correctLetters[i] && proportion < i)) {
                        // Scramble the first half of iterations
                        var randLetter = letterBank.charAt(Math.floor(Math.random() * letterBank.length));
                        iteration[j] = randLetter;

                    }
                }

                // Assure the last iteration is correct
                if (i === iterationNum - 1) {
                    iteration = finWord.split("");
                }

                iterations.push(iteration.slice(0));
            }

            return iterations;
        }
    }



    var animationStartTime,
        lastChangedTime,
        singleDuration = 60,
        totalDuration = 4000,
        wordIterations = [];

    const animateThings = (currTime) => {
        if (window.pageYOffset !== 0) {
            document.body.classList.add("scrolled");
        } else {
            document.body.classList.remove("scrolled");
        }

        if (wordHighlight.current) {
            // Animate the text scrambling
            if (!animationStartTime)
                animationStartTime = currTime;

            if (!lastChangedTime)
                lastChangedTime = currTime;

            const progress = currTime - animationStartTime;
            if (progress > totalDuration) {
                currentNum++;
                if (currentNum >= wordBank.length) {
                    currentNum = 0;
                }

                const numIterations = Math.ceil(Math.random() * (maxNumIterations - minNumIterations)) + minNumIterations;

                wordIterations = getIterations(word.current.innerText, wordBank[currentNum], numIterations);

                currentIteration = 0;

                animationStartTime = currTime;
            }

            const progress3 = currTime - lastChangedTime;
            if (progress3 > singleDuration) {
                if (typeof wordIterations[currentIteration] !== "undefined") {
                    word.current.innerText = wordIterations[currentIteration++].join("");
                    wordHighlight.current.style.width = word.current.offsetWidth + "px";
                }

                lastChangedTime = currTime;
            }


            window.requestAnimationFrame(animateThings);
        }
    }
    window.requestAnimationFrame(animateThings);

    return (
        <div className={styles.main_subheading}>
            I AM <span className={styles.smart} >FULL STACK DEVELOPER</span> <br /> Specialized in
            <span className={styles.word_highlight} ref={wordHighlight}>
                <span ref={word} className={styles.word}> interactive</span>
            </span>.
        </div>
    )
}

export default Text